import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import {LeftCircleOutlined, RightCircleOutlined} from "@ant-design/icons-vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SlideView',
  props: {
    toggle: { type: Boolean }
  },
  emits: ['update:toggle'],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "navigation-box",
      style: _normalizeStyle({width:_ctx.toggle ? '80px' : '188px'})
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4),
    _createVNode(_component_a_button, {
      class: "navigation-footer",
      size: "large",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:toggle', !_ctx.toggle)))
    }, {
      icon: _withCtx(() => [
        (_ctx.toggle)
          ? (_openBlock(), _createBlock(_unref(RightCircleOutlined), { key: 0 }))
          : (_openBlock(), _createBlock(_unref(LeftCircleOutlined), { key: 1 }))
      ]),
      default: _withCtx(() => [
        (!_ctx.toggle)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, "收起"))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}
}

})